export const GET_FOLDER_GRID_VIEW = '/api/folder/folder-detail-grid';

export const GET_FOLDER_DETAIL_GRID_THUMB = '/api/folder/folder-detail-grid';

export const FAVORITE_FOLDER_LIST_ENDPOINT =
  '/api/favorites/favorite-folders-grid-view';
